import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { AUDIENCES } from '../../siteNav';

const ARTIST_IMG = 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/mkb6swuk_3.JPG';

export default function WhoWeWorkWith({ title = 'Who we', accent = 'work with', children }) {
  return (
    <section className="relative bg-black py-24 md:py-32" data-testid="who-we-work-with">
      <div className="max-w-[1500px] mx-auto px-6">
        <h2 className={`font-display text-[#f4efe6] uppercase text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight ${children ? 'mb-8' : 'mb-14'}`}>
          {title} <span className="font-script text-[#00b8ff] normal-case italic">{accent}</span>
        </h2>
        {children}
        <div className="grid gap-6 md:grid-cols-3">
          {AUDIENCES.map((a) => (
            <Link key={a.slug} to={a.to} className="group relative aspect-[4/5] overflow-hidden rounded-md" data-testid={`audience-card-${a.slug}`}>
              <img src={a.img || ARTIST_IMG} alt={a.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent pointer-events-none" />
              <ArrowUpRight className="absolute top-5 right-5 w-6 h-6 text-[#f4efe6] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="absolute inset-x-0 bottom-0 p-7 pointer-events-none">
                <p className="font-display text-[#f4efe6] uppercase text-3xl md:text-4xl tracking-tight leading-tight">{a.name}</p>
                <div className="h-[2px] w-0 bg-[#00b8ff] mt-3 transition-all duration-500 group-hover:w-16" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
